<template>

  <div>

    <vs-input
      v-if="required == false"
      :label="label"
      v-model="decimalValue"
      :readonly="readonly"
      :placeholder="placeholder"
      :class="cssClasses"
      v-on:blur="update"
      :disabled="disable"
    />

    <vs-input
      v-if="required"
      :label="label"
      :readonly="readonly"
      v-model="decimalValue"
      v-validate="'required'"
      :label-placeholder="labelPlaceholder"
      :placeholder="placeholder"
      :name="name"
      :class="cssClasses"
      v-on:blur="update"
      :disabled="disable"
    />
    <span
      v-if="required"
      class="text-danger text-sm"
      v-show="errors.has(name)">{{ errors.first(name) }}</span>

  </div>

</template>

<script>

export default {
  name: 'DecimalInput',
  props: {
    label:{
      default:'',
      type:[String]
    },
    value:{
      default:'',
      type:[String,Number]
    },
    name:{
      default:null,
      type:[String]
    },
    readonly:{
      default:false,
      type:[String,Boolean]
    },
    right:{
      default:false,
      type:[String,Boolean]
    },
    minimumFractionDigits:{
      default:2,
      type:[String,Number]
    },
    thousandsSeparator:{
      default:true,
      type:[String, Boolean]
    },
    isCnpj:{
      default:false,
      type:[String, Boolean]
    },
    disable:{
      default:false,
      type:[String, Boolean]
    },
    isCep:{
      default:false,
      type:[String, Boolean]
    },
    isPositive: {
      default: false,
      type: [String, Boolean]
    },
    placeholder: {
      default: '',
      type: [String]
    },
    labelPlaceholder: {
      default: '',
      type: [String]
    },
  },
  data () {
    return {
      newValue:{
        default:'',
        type:[String,Number]
      },
      required: false,
    }
  },
  beforeMount() {

    this.required = this.name != null;

  },
  computed: {
    decimalValue: {
      get: function () {
        if (this.value == null || this.value === "") {
          return ""
        } else {
          if (this.isCnpj && this.value != null) {
            return this.value.toString()
              .toUpperCase()
              .padStart(14, '0')
              .replace(/[^0-9A-Z]/g, '')
              .replace(/^([0-9A-Z]{2})([0-9A-Z]{3})?([0-9A-Z]{3})?([0-9A-Z]{4})?(\d{2})?/, "$1.$2.$3/$4-$5")
          }
          if (this.isCep && this.value != null) {
            return this.value.toString()
              .padStart(8, '0')
              .replace(/\D/g, '')
              .replace(/^(\d{5})(\d{3})?/, "$1-$2")
          }
          let minimumFractionDigits = this.minimumFractionDigits;
          if (minimumFractionDigits < 0) {
            minimumFractionDigits = 0
          }
          if (this.thousandsSeparator) {
            const formatter = new Intl.NumberFormat('pt-BR', {
              minimumFractionDigits: minimumFractionDigits
            });

            return formatter.format(this.value);
          }
          if (this.isPositive) {
            return Math.abs(Number(this.value))
          }
          return this.value
        }
      },
      set: function (ev) {
        this.newValue = ev;
      },
    },
    cssClasses: {
      get: function () {
        if (this.right) {
          return "w-full text-right"
        } else {
          return "w-full"
        }
      }
    }
  },
  mounted() {
    this.newValue = this.value;
  },
  methods: {
    update: function () {
      if (this.newValue === "") {
        this.$emit('input', "");
        return
      }

      if (this.isCnpj) {
        this.$emit('input', this.newValue.toString().toUpperCase().replace(/[^0-9A-Z]/g, ''))
        return
      }

      let result = Number(this.newValue.replace('.', '').replace(',', '.'));
      if (isNaN(result)) {
        this.$emit('input', this.newValue.replace(',', '.').replace(/\D/g, ''))
      } else {
        this.$emit('input', result)
      }
    }
  }
}
</script>
<style scoped>
/* Don't forget to hide the original file input! */
.text-align-right {
  text-align: right;
}
</style>
